import {
	MessageBackend as createMessageBackendJiraNinListMergeModalOnboardingV2,
	MessageFrontend as createMessageFrontendJiraNinListMergeModalOnboardingV2,
} from '@post-office/message-template--jira-nin-list-merge-modal-onboarding-v2/placements/in-app-v2/issue-navigator-placement';
import {
	MessageBackend as createMessageBackendJiraNinListMergeSpotlightOnboardingV2,
	MessageFrontend as createMessageFrontendJiraNinListMergeSpotlightOnboardingV2,
} from '@post-office/message-template--jira-nin-list-merge-spotlight-onboarding-v2/placements/in-app-v2/issue-navigator-placement';
import {
	MessageBackend as createMessageBackendJiraNinPaidListMergeModalOnboarding,
	MessageFrontend as createMessageFrontendJiraNinPaidListMergeModalOnboarding,
} from '@post-office/message-template--jira-nin-paid-list-merge-modal-onboarding/placements/in-app-v2/issue-navigator-placement';
import { productionRuntime } from '@post-office/placement-common-v2/placement-runtime';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--jira-empanada/issue-navigator-placement';

import { withI18n } from './i18n';

const messageBackends = [
	createMessageBackendJiraNinListMergeModalOnboardingV2({
		messageTemplateId: 'jira-nin-list-merge-modal-onboarding-v2',
	}),
	createMessageBackendJiraNinListMergeSpotlightOnboardingV2({
		messageTemplateId: 'jira-nin-list-merge-spotlight-onboarding-v2',
	}),
	createMessageBackendJiraNinPaidListMergeModalOnboarding({
		messageTemplateId: 'jira-nin-paid-list-merge-modal-onboarding',
	}),
];

const messageFrontends = [
	createMessageFrontendJiraNinListMergeModalOnboardingV2({
		messageTemplateId: 'jira-nin-list-merge-modal-onboarding-v2',
	}),
	createMessageFrontendJiraNinListMergeSpotlightOnboardingV2({
		messageTemplateId: 'jira-nin-list-merge-spotlight-onboarding-v2',
	}),
	createMessageFrontendJiraNinPaidListMergeModalOnboarding({
		messageTemplateId: 'jira-nin-paid-list-merge-modal-onboarding',
	}),
];

export const placementBackendFactory = PlacementBackend.createPlacementBackend({
	messageTemplates: messageBackends,
});

export const RawPlacement = PlacementFrontend.createPlacementFrontendComponent({
	messageTemplates: messageFrontends,
});

export const Placement = withI18n(RawPlacement);

export const SSRPlacement = RawPlacement;

export const middleware = placementBackendFactory(productionRuntime);
